
import { defineComponent, defineAsyncComponent } from "vue";
import { VNode } from "vue";
import { mapState } from "vuex";
import Modal from "@/components/Modal.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import getScoreColorClass from "@/helper/scoreColorClass";

export default defineComponent({
  name: "GameHelpModal",

  components: {
    Modal,
    SvgIcon,
  },

  computed: {
    ...mapState(["game"]),
    hasHighscore(): boolean {
      return this.$store.getters.hasHighscore(this.game);
    },
    gameHelperComponent(): VNode {
      return defineAsyncComponent(
        () => import(`@/components/gameHelp/${this.game}Help.vue`)
      );
    },
    currentHighscore(): string {
      return this.$store.getters.getHighscoreByGameName(this.game);
    },
    extraPointsClasses(): string {
      return getScoreColorClass(this.currentHighscore, this.game);
    },
    isTimeScore(): boolean {
      return this.$store.getters.getScoreTypeByGameName(this.game) === "time";
    },
  },

  methods: {
    deleteHighscore() {
      this.$store.dispatch("removeHighscore");
    },
  },
});
